export const _bipFr = {
    loading: 'Chargement de votre bip NexSimu',
    cancelled: 'Départ annulé',
    disconnected: 'Déconnecté',
};

export const _bipEn = {
    loading: 'Loading your NexSimu bip',
    cancelled: 'Departure cancelled',
    disconnected: 'Disconnected',
};

export const _bipDe = {
    loading: 'Laden Sie Ihren NexSimu-Bip',
    cancelled: 'Abfahrt abgesagt',
    disconnected: 'Getrennt',
};
